export interface QuizMapping {
	uuid: string;
	name: string;
	quiz_metadata: QuizMetadata;
	overall_score?: number;
	completion_date?: number;
	quizes: Quiz[];
}

export interface QuizMetadata {
	uuid: string;
	properties: QuizMetadataProperties;
	name: string;
	description: string;
	max_attempts: number;
	quiz_duration_minutes: number;
	question_per_quiz: number;
	minimum_passing_score: number;
	image?: string,
	last_modified?: number;
}

export interface QuizMetadataProperties {
	vertical_id?: string;
	device_ids: number[];
}

export interface Quiz {
	quiz_uuid: string;
	start_time?: number | null;
	current_time?: number | null;
	score?: number | null;
	progress: number;
	questions: Question[];
	attempt_uuid?: string | null;
}

export interface Question {
	uuid: string;
	quiz_uuid: string;
	text: string;
	devices: number[];
	image?: string;
	type: number;
	options: QuestionOption[];
	position_in_quiz?: number;
	max_correct?: number;
}

export interface QuestionOption {
	uuid: string;
	text: string;
	image?: string;
}

export interface AnsweredQuestion extends Question {
	submitted_at: number;
	score: number;
	answers?: string[];
}

export interface AdminEditableQuestion extends Question {
	correct_answers: string[];
}

export type AnsweredQuestionWithCorrectAnswers = AnsweredQuestion & AdminEditableQuestion;

export enum QuizStatus {
	NOT_STARTED = "not_started",
	IN_PROGRESS = "in_progress",
	COMPLETED_PASSED = "completed_passed",
	COMPLETED_FAILED = "completed_failed",
	NO_ATTEMPTS_LEFT = "no_attempts_left",
}

